import React, { useState } from "react";
import Button from "_shared/components/Button/Button";
import CustomModal from "../Modal";
import styles from "./ConfirmationModal.module.scss";

interface Props extends React.ComponentProps<typeof CustomModal> {
  onConfirm: () => Promise<void>;
}

const ConfirmationModal: React.FC<Props> = ({
  onConfirm,
  onClose,
  children,
  ...rest
}) => {
  const [loading, setLoading] = useState(false);

  const confirmLoader = async () => {
    setLoading(true);
    await onConfirm();
    setLoading(false);
    onClose();
  };

  return (
    <CustomModal onClose={onClose} {...rest}>
      <div className={styles.container}>
        <i className="fas fa-exclamation-triangle" />
        {children}
      </div>
      <div className="footer-buttons">
        <Button
          onClick={onClose}
          variant="secondary"
          data-testid="button-cancel"
        >
          Cancel
        </Button>
        <Button
          loading={loading}
          onClick={confirmLoader}
          data-testid="button-confirm"
        >
          Confirm
        </Button>
      </div>
    </CustomModal>
  );
};

export default ConfirmationModal;
